import { Translation } from '@shared/types/translation';

export const FACILITY_LABELS = {
  EMPLOYEE_LIST_EMPTY: {
    english: 'No employees added yet.',
    polish: 'Nie dodano jeszcze żadnych pracowników.',
  },
  EMPLOYEE_DIALOG_TITLE_DEACTIVATE: {
    english: 'Deactivate Employee?',
    polish: 'Dezaktywować pracownika?',
  },
  // Prefix rendered immediately before the employee's name in the confirm
  // dialog content, e.g. "{prefix}{name}?" — trailing space is intentional.
  EMPLOYEE_DIALOG_CONFIRM_PREFIX_DEACTIVATE: {
    english: 'Are you sure you want to deactivate ',
    polish: 'Czy na pewno chcesz dezaktywować pracownika ',
  },
  DEACTIVATE_EMPLOYEE_SUCCESS: {
    english: 'Employee has been deactivated successfully.',
    polish: 'Pracownik został pomyślnie dezaktywowany.',
  },
  EMPLOYEE_DIALOG_TITLE_ACTIVATE: {
    english: 'Activate Employee?',
    polish: 'Aktywować pracownika?',
  },
  // Prefix rendered immediately before the employee's name in the confirm
  // dialog content, e.g. "{prefix}{name}?" — trailing space is intentional.
  EMPLOYEE_DIALOG_CONFIRM_PREFIX_ACTIVATE: {
    english: 'Are you sure you want to activate ',
    polish: 'Czy na pewno chcesz aktywować pracownika ',
  },
  ACTIVATE_EMPLOYEE_SUCCESS: {
    english: 'Employee has been activated successfully.',
    polish: 'Pracownik został pomyślnie aktywowany.',
  },
  ADD_EMPLOYEE_BUTTON_LOADING: {
    english: 'Adding Employee...',
    polish: 'Dodawanie pracownika…',
  },
  EQUIPMENT_LIST_EMPTY: {
    english: 'No equipment added yet.',
    polish: 'Nie dodano jeszcze żadnej aparatury.',
  },
} as const satisfies Record<string, Translation>;
